module.exports = __webpack_public_path__ + "img/icon-mysql.f0d174ee.svg";